// @ts-nocheck
import * as React from "react";

const BellOffFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M5.31 8.14L6.58 9.4l7.35 7.31.07.07 1.29 1.34.59.59.12.07A3.88 3.88 0 0112 22l-.197.003A3.84 3.84 0 018 18.34V18H4.64a1.64 1.64 0 01-1.13-2.79l1.8-1.81V8.73a5.68 5.68 0 010-.59zM3.29 3.29a1.004 1.004 0 011.42 0l3.18 3.18L17.41 16l2 2 1.3 1.29a1 1 0 010 1.42 1.002 1.002 0 01-1.42 0L16.59 18l-2-2-7.31-7.3L5.53 7 3.29 4.71l-.084-.095A1.004 1.004 0 013.29 3.29zM14 18h-4v.34A1.88 1.88 0 0012 20l.15.005A1.88 1.88 0 0014 18.34V18zM7.802 3.483A6.71 6.71 0 0112.9 2.06l.235.04a6.86 6.86 0 015.595 6.84v4.46l1.8 1.81c.47.466.608 1.17.35 1.78l-.066.137a1.58 1.58 0 01-.384.463l-.31-.3L7.13 4.3 7 4.21a6.88 6.88 0 01.58-.54z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(BellOffFill);
